import { InputNumber, message, Select, Modal as AntModal, Tag, Button, Form, FormInstance } from 'antd';
import { t } from 'i18next';
import React, { createRef } from 'react';
import { Modal } from 'react-bootstrap';
import { CurrencyEuro, Trash } from 'react-bootstrap-icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import Order from '../../../../Model/models/orderModel';
import OrderProduct from '../../../../Model/models/orderProductModel';
import ProductType from '../../../../Model/productType';
//import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import constants from '../../../../constants';
import { OrderFormUtils, VATs } from '../../../../utils/orderFormUtils';
import authAxios from '../../../../authorization/axios';

interface OrderFormItemsProps extends WithTranslation {
  order: Order,
  editItems: boolean,
  productTypes: ProductType[],
  currencySymbol: string,
  updateOverview: (edit?: boolean) => void,
  onItemsChange: (orderProducts: OrderProduct[]) => void,
  showModal: () => void,
  hideModal: () => void,
  modalData: boolean;
}

interface OrderFormItemsState {
  order: Order,
  editItems: boolean,
  productName: string,
  productTypeId?: number,
  productQuantity: number,
  productPrice?: number,
  productVat: number,
  productDiscount: number,
  discountedPrice: number,
  discountedPriceWithVat: number,
  productStatus?: string,
  error: {
    message: string,
    error: boolean;
  };
}

class OrderFormItems extends React.Component<OrderFormItemsProps, OrderFormItemsState> {

  addProductForm = createRef<FormInstance>();

  constructor(props: OrderFormItemsProps) {
    super(props);
    this.state = {
      editItems: props.editItems,
      order: props.order,
      productName: '',
      productTypeId: undefined,
      productQuantity: 1,
      productPrice: 0,
      productDiscount: 0,
      productVat: 0,
      discountedPrice: 0,
      discountedPriceWithVat: 0,
      error: {
        message: '',
        error: false
      }
    };
  }

  layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 16 }
  };

  shouldComponentUpdate(nextProps: OrderFormItemsProps) {
    if (nextProps.order !== this.state.order) {
      this.setState({ order: nextProps.order });
    }
    if (nextProps.editItems !== this.state.editItems) {
      this.setState({ editItems: nextProps.editItems });
    }
    return true;
  }

  addProduct = () => {
    const { order, productTypes } = this.props;
    const productType = productTypes.find(item => item.id === this.state.productTypeId);
    const { productVat, productPrice, productQuantity, productStatus, productDiscount } = this.state;
    if (productType && productQuantity > 0 && productPrice !== undefined) {
      const orderP = order.orderProducts.find(item => item.friendly_name === this.state.productName &&
        item.status === this.state.productStatus &&
        (item?.vat / item?.quantity) === (this.state?.productVat / this.state?.productQuantity) &&
        item.price === this.state.discountedPriceWithVat);
      if (orderP) {
        orderP.quantity = orderP.quantity + this.state.productQuantity;
        orderP.vat = orderP.vat + this.state.productVat;
      } else {
        const price = productPrice * (1 - (productDiscount / 100));
        order.orderProducts.push({
          product_type_id: productType.id,
          order: order.id,
          friendly_name: (productType as any).friendlyName,
          price,
          quantity: productQuantity,
          vat: Math.round(price * productQuantity * productVat) / 100,
          status: productStatus || undefined
        });
      }
      this.props.updateOverview();
      this.props.onItemsChange(order.orderProducts);
      this.setState({
        productName: '',
        productTypeId: undefined,
        productQuantity: 1,
        productPrice: 0,
        productDiscount: 0,
        productVat: 0,
        discountedPrice: 0,
        discountedPriceWithVat: 0
      });
      return true;
    } else {
      message.error(this.props.t('MISS_FIELD'));
      return false;
    }
  };

  makePartialRefund = (product: any, index: number) => {
    const order = this.props.order;
    let qty = 0;
    const self = this;

    const modal = AntModal.confirm({
      title: self.props.t('HOW_MANY_PRODUCT_TO_REFUND'),
      content: (
        <InputNumber type="number" min="0" max={product.quantity} onChange={(event) => { qty = event as number; }} />
      ),
      okText: this.props.t('REFUND'),
      cancelText: this.props.t('CANCEL'),
      cancelButtonProps: { hidden: false },
      onOk() {
        const vat4unit = product.vat / product.quantity;
        const delta = product.quantity - qty;
        if (delta < 0) {
          message.error({
            content: self.props.t('NO_ENOUGH_QTY'),
            style: { marginTop: 100 }
          });
          return;
        }
        product.quantity -= qty;
        product.vat = vat4unit * product.quantity;
        if (delta === 0) {
          order.orderProducts.splice(index, 1);
        }

        const refundLine = order.orderProducts.find(op => op.product_type_id === product.product_type_id &&
          ['refunded', 'partial_refund'].indexOf(op.status || 'completed') > -1
        );
        if (refundLine) {
          const refundLine4unit = refundLine.vat / refundLine.quantity;
          refundLine.quantity += qty;
          refundLine.vat = refundLine.quantity * refundLine4unit;
        } else {
          order.orderProducts.push({
            product_type_id: product.product_type_id,
            order: order.id,
            friendly_name: product.friendly_name,
            price: product.price,
            quantity: qty,
            vat: vat4unit * qty,
            status: 'partial_refund'
          });
        }
        self.props.updateOverview(false);
        self.setState({ order });
        self.props.onItemsChange(order.orderProducts);
      },
      onCancel() {
        modal.destroy();
      }
    });
  };

  render() {
    const { order, productTypes, currencySymbol } = this.props;
    return <>
      <Modal show={this.props.modalData} backdrop={true} keyboard={true} size='xl' onHide={this.props.hideModal}>
        <Modal.Header>
          <Modal.Title>{t('ADD_PRODUCT')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form
            {...this.layout}
            ref={this.addProductForm}
            initialValues={{
              quantity: this.state.productQuantity
            }}
          >
            <Form.Item
              label={t('PRODUCT_TYPE')}
              name="productType"
              rules={[{ required: true, message: 'Please select a product type!' }]}
            >
              <Select value={this.state.productName} style={{ width: 250 }} onChange={async (value: string) => {
                let state = {
                  productTypeId: parseInt(value),
                  productName: value,
                  productPrice: 0
                };
                try {
                  const result = await authAxios.get(constants.api.getProductCurrency
                    .replace('{id}', value)
                    .replace('{currency}', order.currency || 'NO-VALUE')
                  );
                  if (result.data?.data) {
                    state.productPrice = result.data.data.price;
                    this.addProductForm.current?.setFieldsValue({ cost: result.data.data.price });
                  } else {
                    this.addProductForm.current?.setFieldsValue({ cost: '' });
                  }
                } catch (error: any) {
                  console.log(error.message);
                }
                this.setState(state);
              }}>
                {productTypes.map((item: any) => {
                  return <Select.Option value={item.id} key={item.friendlyName}>
                    {item.friendlyName}
                  </Select.Option>;
                })}
              </Select>
            </Form.Item>

            <Form.Item
              label={t('QUANTITY')}
              name="quantity"
              rules={[{ required: true, message: 'Please input quantity!' }]}
            >
              <InputNumber style={{ width: 250 }}
                type="number"
                name={'product.quantity'}
                min={1}
                value={this.state.productQuantity}
                onChange={(event) => {
                  if (event !== null) {
                    this.setState({ productQuantity: event });
                  }
                }} />
            </Form.Item>

            <Form.Item
              label={t('COST')}
              name="cost"
              rules={[{ required: true, message: 'Please input cost!' }]}
            >
              <InputNumber
                style={{ width: 250 }}
                type="number"
                name={'product.price'}
                min={0}
                value={this.state.productPrice}
                onChange={(event) => {
                  if (this.state.productPrice !== undefined) {
                    const discount = (this.state.productPrice * this.state.productQuantity) * (this.state.productDiscount / 100);
                    if (event !== null) {
                      this.setState({ productPrice: event });
                      this.setState({ discountedPrice: (event * this.state.productQuantity) - discount });
                      if (this.state.productVat !== 0) {
                        const discountPrice = ((event * this.state.productQuantity) - discount);
                        const vatPrice = discountPrice * (this.state.productVat / 100);
                        const price = (event * this.state.productQuantity) - discount;
                        this.setState({ discountedPrice: price + vatPrice });
                      }
                    }
                  }
                }} />
            </Form.Item >

            <Form.Item
              rules={[{ required: true, message: 'Please input discount!' }]}
              label={t('DISCOUNT')}
              name="discount">
              <Select
                style={{ width: 250 }}
                onChange={(value: number) => {
                  if (this.state.productPrice !== undefined) {
                    this.setState({ productDiscount: value });
                    const discount = (this.state.productPrice * this.state.productQuantity) * (value / 100);
                    this.setState({ discountedPrice: (this.state.productPrice * this.state.productQuantity) - discount });
                    if (this.state.productVat !== 0) {
                      const discountPrice = ((this.state.productPrice * this.state.productQuantity) - discount);
                      const vatPrice = discountPrice * (this.state.productVat / 100);
                      const price = (this.state.productPrice * this.state.productQuantity) - discount;
                      this.setState({ discountedPrice: price + vatPrice });
                    }
                  }
                }}>
                <Select.Option value={0}>0%</Select.Option>
                <Select.Option value={5}>5%</Select.Option>
                <Select.Option value={10}>10%</Select.Option>
                <Select.Option value={15}>15%</Select.Option>
                <Select.Option value={20}>20%</Select.Option>
                <Select.Option value={25}>25%</Select.Option>
                <Select.Option value={30}>30%</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: 'Please input vat!' }]}
              label={t('VAT')}
              name="vat">
              <Select style={{ width: 250 }} onChange={(id: string) => {
                const value = parseInt(id?.split('-')[0]);
                if (this.state.productPrice !== undefined) {
                  if (value !== this.state.productVat) {
                    const discount = (this.state.productPrice * this.state.productQuantity) * (this.state.productDiscount / 100);
                    this.setState({
                      discountedPrice: (this.state.productPrice * this.state.productQuantity) - discount,
                      productVat: value
                    });
                    if (value !== 0) {
                      // this.setState({ discountedPrice: (this.state.productPrice * this.state.productQuantity) - discount });
                      const vatPrice = ((this.state.productPrice * this.state.productQuantity) -
                        discount) * (value / 100);
                      const price = (this.state.productPrice * this.state.productQuantity) - discount;
                      this.setState({ discountedPrice: price + vatPrice });
                    }
                  }
                }
              }}>
                {VATs.sort((a, b) => a.country.localeCompare(b.country))
                  .map((vat, index) => <Select.Option key={`vat-${index}`} value={`${vat.percentage}-${vat.country}`}>
                    {vat.percentage}% {vat.country}
                  </Select.Option>)}
                <Select.Option value={'0-Other'}>
                  0% Other
                </Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label={t('PRICE')}
              name="price">
              {OrderFormUtils.getPriceFormat(this.state.discountedPrice || 0, currencySymbol)}
            </Form.Item>


            {/* <Form.Item
              label={t('STATE')}
              name="state"
            >
              <Select style={{ width: 250 }}
                onChange={(value) => this.setState({ productStatus: value?.toString() || undefined })}>
                <Select.Option value="partial_refund">{this.props.t('REFUNDED')}</Select.Option>
                <Select.Option value={''}>{this.props.t('-')}</Select.Option>
              </Select>
            </Form.Item> */}
          </Form>
          {this.state.error.error && <div className='error'>
            {this.state.error.message}
          </div>}
        </Modal.Body>
        <Modal.Footer>
          <Button type='default' onClick={() => { this.setState({ productPrice: 0, productQuantity: 0 }); this.props.hideModal(); }}>
            {t('CLOSE')}
          </Button>
          <Button type="primary" onClick={() => {
            if (this.state.productName && this.state.productQuantity) {
              this.addProduct();
              this.props.hideModal();
            } else {
              this.setState({
                error: {
                  message: this.props.t('MISS_FIELD'),
                  error: true
                }
              });
            }
          }}>
            {t('SAVE_CHANGES')}
          </Button>
        </Modal.Footer>
      </Modal>
      {
        (!order.orderProducts || order.orderProducts.length === 0) && !this.state.editItems &&
        <tr>
          <td></td>
          <td colSpan={6} className="text-center">{this.props.t('NO_RESULTS')}</td>
        </tr>
      }
      {
        !this.state.editItems &&
        order.orderProducts.map((product) => <>
          {
            <tr key={`${product.product_type_id}-${product.status}`} className='align-top'>
              <td></td>
              <td className="bottomLine">
                {product.friendly_name}
              </td>
              <td className="bottomLine">
                x{product.quantity}
              </td>
              <td className="bottomLine">
                {OrderFormUtils.getPriceFormat(product.price, currencySymbol)}
              </td>
              <td className="bottomLine">
                {OrderFormUtils.getPriceFormat(product.price * product.quantity, currencySymbol)}
              </td>
              <td className="bottomLine">
                {OrderFormUtils.getPriceFormat(product.vat, currencySymbol)}
              </td>
              <td className="bottomLine">
                {
                  (product.status === 'partial_refund' || product.status === 'refunded') &&
                  <Tag color="red">{this.props.t('REFUNDED')}</Tag>
                }
                {!product.status && <Tag color="green">{this.props.t('COMPLETED')}</Tag>}
              </td>
            </tr>
          }
        </>
        )}
      {this.state.editItems &&
        <>
          {
            order.orderProducts.map((product, index) => <>
              <tr key={`${product.product_type_id}-${product.status}`} className='align-top editItem'>
                <td>
                  <input type="hidden" name="product.id" defaultValue={product.id} />
                </td>
                <td className="bottomLine">{product.friendly_name}</td>
                <td className="bottomLine">
                  <InputNumber readOnly={!!product.status} type="number"
                    name={'product.quantity'} min={1} value={product?.quantity || 1}
                    onChange={(event) => {
                      const p = order.orderProducts[index];
                      const vat4unit = Math.round((p.vat / p.quantity) * 100) / 100;
                      p.quantity = event ?? p.quantity;
                      p.vat = Math.round((vat4unit * p.quantity) * 100) / 100;
                      this.setState({ order: order });
                      this.props.updateOverview();
                    }} />
                </td>
                <td className="bottomLine">
                  <InputNumber readOnly={!!product.status} type="number" name={'product.price'}
                    min={0} value={product?.price || 0}
                    onChange={(event) => {
                      const p = order.orderProducts[index];
                      p.price = event ?? p.price;
                      this.setState({ order: order });
                      this.props.updateOverview();
                    }}
                  />
                </td>
                <td className="bottomLine">
                  {OrderFormUtils.getPriceFormat((product.price * product.quantity) || 0, currencySymbol)}
                </td>
                <td className="bottomLine">
                  <InputNumber readOnly={!!product.status}
                    type="number"
                    name={'product.vat'}
                    min={0}
                    value={product?.vat || 0}
                    onChange={(event) => {
                      const p = order.orderProducts[index];
                      p.vat = event ?? p.vat;
                      this.setState({ order: order });
                      this.props.updateOverview();
                    }}
                  />
                </td>
                <td className="bottomLine">
                  {
                    (product.status === 'partial_refund' || product.status === 'refunded') &&
                    <Tag color="red">{this.props.t('REFUNDED')}</Tag>
                  }
                  {!product.status && <Tag color="green">{this.props.t('COMPLETED')}</Tag>}
                </td>
                <td style={{ display: 'flex' }}>
                  {
                    !product.status &&
                    <button className="warnButton my-2" style={{ marginRight: '0.25em' }}
                      onClick={() => this.makePartialRefund(product, index)}>
                      <CurrencyEuro />
                    </button>
                  }
                  <button className="closeButton my-2" style={{ marginRight: '0.25em' }}
                    onClick={() => {
                      order.orderProducts.splice(index, 1);
                      this.props.updateOverview();
                      this.setState({});
                    }}>
                    <Trash />
                  </button>
                </td>
              </tr>
            </>)
          }
        </>
      }
    </>;
  }

}

export default withTranslation()(OrderFormItems);